export const Routes = {
  home: '/home',
  aboutUs: '/about-us',
  prices: '/prices',
  contacts: '/contacts',
  portfolio: '/portfolio',
};
